<template>
  <div
    class="scene-lightColorSet"
    @mousemove="onImgUpMove"
    @mouseup="onImgUp"
  >
    <div class="scene_title blue_header">
      <span>{{ $t("sceneCard.base") }}</span>
    </div>
    <SceneBgSelect
      ref="sceneBgSelect"
      :shape-type="2"
      :from="from"
      @imgUpdate="onImgUpdate"
    />
    <div
      class="scene-splicing-view"
      @mousedown="onImgDown"
    >
      <div
        id="scene-splicing-view-shoot"
      >
        <img
          class="scene-splicing-view_bg"
          :src="bg"
          :style="splicingBgStyle"
        >
      </div>
      <div
        class="scene-splicing-view_blockContainer"
        :style="blockContainerStyle"
      >
        <div
          v-for="(item, index) in splicingView"
          id="scene-splicing-view_block"
          :key="index"
          :class="{
            'scene-splicing-view_block': true,
            'circle': template.shape === 1,
            'is-hole': isSplicingHole(index)
          }"
          :style="item"
        >
          <span
            v-if="isShowNumSpan && !isSplicingHole(index)"
            :class="activeSplicingView === index ? 'active' : ''"
            @mousedown.stop="() => {}"
            @mouseup.stop="(e) => changeActiveSplicingView(e, index)"
          >
            {{ index + 1 }}
          </span>
        </div>
      </div>
      
      <div
        class="scene-splicing-view_scale"
      >
        <span
          @mousedown.stop="() => onScale(0)"
        >
          -
        </span>
        {{ (splicingBgStyle.scale * 100).toFixed(0) }}%
        <span
          @mousedown.stop="() => onScale(1)"
        >
          +
        </span>
      </div>
    </div>
    <div
      class="scene-lightColorSet_row"
    >
      <div>
        <div class="scene-lightColorSet_main" :style="{ height: sceneLightColorSetMainHeight + 'px' }">
          <img
            :src="template.deviceBg"
            :class="{
              'scene-lightColorSet_main_pngBg': true, 
              mirror: isNeedMirror
            }"
          >
          <canvas id="scene-lightColorSet_canvas" width="700" :height="sceneLightColorSetMainHeight" />
          <canvas id="scene-lightColorSet_canvas-virtually" width="700" :height="sceneLightColorSetMainHeight" />
          <!-- <img
          class="scene-lightColorSet_main_bg"
          :src="bg"
          :style="bgStyle"
        > -->
          <div class="scene-lightColorSet_main_masker" />
          <ul 
            v-if="renderList[activeSplicingView] && !isSplicingHole(activeSplicingView)"
            class="scene-lightColorSet_main_positionList"
          >
            <li
              v-for="(item, index) in renderList[activeSplicingView]"
              :key="index"
              :class="{ active: item.isSelected, hasEdit: item.hasEdit }"
              :style="{ background: item.switch ? imageMode === 1 ? item.color : item.sdlColor : '#000', left: item.position.x + 'px', top: item.position.y + 'px'}"
              @click="() => handlerItemClick(item, index)"
              @dblclick="() => handlerItemDbClick(item, index)"
            >
              {{ item.id }}
              <div
                v-if="item.hasEdit"
                class="scene-lightColorSet_main_positionList_edit"
              />
            </li>
          </ul>
        </div>
        <div class="scene-lightColorSet_row_modeSelect">
          <div :class="{active: imageMode === 1}" @click="imageMode = 1">
            {{ $t("sceneTemplate.originalImage") }}
          </div>
          <div :class="{active: imageMode === 2}" @click="imageMode = 2">
            {{ $t("sceneTemplate.sdlColor") }}
          </div>
        </div>
      </div>
      <div
        v-show="hasSelectItem"
        class="scene-lightColorSet_control"
      >
        <div
          class="scene-lightColorSet_control_switchs"
        >
          <div
            class="scene-lightColorSet_control_switchs_item"
          >
            <span>{{ $t('sceneCard.lightSwitch') }}</span>
            <el-switch
              v-model="switchValue"
              active-color="#7dacee"
              inactive-color="#d9e2f0"
              :active-value="1"
              :inactive-value="0"
              @change="onSwitchValue"
            />
          </div>
          <div
            v-if="shadowAction"
            class="scene-lightColorSet_control_switchs_item"
          >
            <span>{{ $t('sceneTemplate.shadowEffect') }}</span>
            <el-switch
              v-model="shadowValue"
              active-color="#7dacee"
              inactive-color="#d9e2f0"
              :active-value="1"
              :inactive-value="0"
              @change="onShadowValue"
            />
          </div>
        </div>
        <div class="scene-lightColorSet_control_item">
          <div class="scene-lightColorSet_control_label">
            {{ $t("sceneTemplate.lampMode") }}
          </div>
          <div class="scene-lightColorSet_control_value">
            <el-radio-group v-model="lightMode">
              <el-radio :label="1">
                {{ $t('deviceMsg.lightMode1') }}
              </el-radio>
              <el-radio :label="2">
                {{ $t('deviceMsg.lightMode2') }}
              </el-radio>
            </el-radio-group>
          </div>
        </div>
        <LightDuvControl
          v-if="optionRange"
          ref="LightDuvControl"
          :show-duv="lightMode === 1"
          :show-temperature="lightMode === 1"
          :option="option"
          :option-range="optionRange"
          @change="onOptionChange"
        />
        <div
          v-show="lightMode === 2"
          class="scene-lightColorSet_control_item colorPicker"  
        >
          <div class="scene-lightColorSet_control_label">
            {{ $t("sceneTemplate.selectColor") }}
          </div>
          <div class="scene-lightColorSet_control_value">
            <div class="scene-lightColorSet_control_colorPicker">
              <div class="scene-lightColorSet_control_color" :style="{ background: lightBg }" />
              <Panel
                v-if="colorAction"
                ref="colorPanl"
                :color="colorModel"
                :config="{ config: colorAction.UI?.extra, matrix: colorAction.UI?.extra?.matrix }"
                :image="colorAction.Icon"
                @handlePanelColor="onCaiGuangSubmit"
              />
              <p class="scene-lightColorSet_control_cxcyText">
                cx: <el-input
                  :value="showCxCy.cx"
                  @input="val => handleCxCyInput('cx', val)"
                  @keyup.native.enter="onCxCyChange"
                  @blur="onCxCyChange"
                />
                cy: <el-input
                  :value="showCxCy.cy"
                  @input="val => handleCxCyInput('cy', val)"
                  @keyup.native.enter="onCxCyChange"
                  @blur="onCxCyChange"
                />
              </p>
              <!-- <el-color-picker
                v-model="colorModel"
                class="scene-lightColorSet_color-picker"
                popper-class="color-picker-box"
                size="medium"
                color-format="rgb"
                @change="onCaiGuangSubmit"
              /> -->
            </div>
          </div>
          <div
            class="scene-lightColorSet_control_submit"
            @click="onCancelAll"
          >
            {{ $t("otatask.resumeOperate") }}
          </div>
        </div>
        <div v-show="lightMode === 1" class="scene-lightColorSet_control_btnList">
          <div
            class="scene-lightColorSet_control_submit"
            @click="onCancelAll"
          >
            {{ $t("otatask.resumeOperate") }}
          </div>
          <!-- <div
            class="scene-lightColorSet_control_submit"
            @click="onRiguangcSubmit"
          >
            {{ $t("base.sure") }}
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SceneBgSelect from './SceneBgSelect.vue';
import Panel from '@/components/deviceAction/colorPicker/components/panel.vue';
import SliderWithInput from "@/components/button/SliderWithInput";
import LightDuvControl from "./LightDuvControl";
// import InnerColorPicker from '@/components/button/InnerColorPicker'
// import ColorPicker from '@/components/deviceAction/colorPicker/main.vue';
import { FindActionAbilityWithStatus } from '@/axios/IDevice.js';
import { transformPointToCXCY, OppColorCvrtCIExy2sRgb, transformPointToSdlRgb, rgbToHex } from '@/components/DesignCanvas/utils/common';
import { CxCyToRGBHex, ValueToCxCy } from '@/utils/colors';
import { getPixelColor, getRuleSize, hexToRgb } from '../utils.js';
import {UICONTROL_CX_CY_WithMode_ARRAY} from '@/utils/enums'

const LI_WIDTH = 20;

function getTemperatureColor(value, [min, max]) {
  let step = Math.floor(((value - min) / (max -  min)) / 0.125);

  step = Math.min(step, 7);

  const colorList = [
    { r: 255, g: 153, b: 0 },
    { r: 255, g: 204, b: 128 },
    { r: 255, g: 251, b: 243 },
    { r: 244, g: 244, b: 245 },
    { r: 218, g: 232, b: 252 },
    { r: 192, g: 216, b: 253 },
    { r: 139, g: 184, b: 255 },
    { r: 116, g: 171, b: 255 },
  ];

  return colorList[step] || { r: 255, g: 153, b: 0 };
}

export default {
  components: {
    SliderWithInput,
    SceneBgSelect,
    Panel,
    LightDuvControl,
  },
  props: {
    from: {
      type: String,
      default: null
    },
    template: {
      type: Object,
      default: () => ({})
    },
    device: {
      type: Object,
      default: () => ({})
    },
    optionRange: {
      type: Object,
      default: () => null
    },
    defaultOptionAche: {
      type: Object,
      default: () => ({
        light: 255
      })
    },
    colRowOption: {
      type: Object,
      default: () => null
    },
    matrixValueUi: {
      type: Object,
      default: () => null
    },
    shadowAction: {
      type: Object,
      default: () => null
    },
    deviceList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isNeedMirror: true,
      bg: '',
      colorModel: '',
      lightBg: '',
      renderList: [],
      activeSplicingView: 0, // 激活的板块或者设备
      lightMode: 1,
      imageMode: 1,
      option: {
        light: 255,
        duv: -4,
        temperature: 2800,
      },
      bgStyle: {},
      colorAction: null,
      splicingView: [],
      mouseDownAche: {
        left: null,
        top: null,
      },
      splicingBgStyleAche: {
        left: 0,
        top: 0,
      },
      splicingBgStyle: {
        left: 0,
        top: 0,
        scale: 1
      },
      blockContainerStyle: {},
      // blockContainerWidth: 300,
      // blockContainerHeight: 300,
      isShowNumSpan: true,
      switchValue: 1,
      shadowValue: 1,
      ctx: null,
      ctxVirtually: null,
      sceneLightColorSetMainHeight: 700,
      blockContainerData: {},
      showCxCy: {
        cx: 0,
        cy: 0
      },
      // 挖洞拼图下标（写 Mark4；不影响下发）
      splicingHoleIndexes: [],
      // splicingBgScale: 100
    }
  },

  computed: {
    hasSelectItem() {
      if (this.isSplicingHole(this.activeSplicingView)) return false;
      return (this.renderList[this.activeSplicingView] || []).some(item => item.isSelected);
    }
  },

  watch: {
    colRowOption(val) {
      console.log('colRowOption bianle', val);
    },
    splicingBgStyle() {
      console.log('this.splicingBgStyle', this.splicingBgStyle);
      
    },
    deviceList: {
      deep: true,
      handler() {
        this.ensureActiveSplicingView();
      }
    }
  },

  mounted() {
    if (!this.colRowOption) return;

    const { col, row } = this.colRowOption;
    // const size = Math.floor(300 / Math.max(col, row));
// console.log('col, row', col, row);

    const { allWidth, allHeight, singleWidth, singleHeight, left, top, total, unitScale } = getRuleSize({
      stageSize: 300,
      col, 
      row, 
      scale: this.template.scale
    });
    
    this.blockContainerData = {
      allWidth, allHeight, singleWidth, singleHeight, left, top, total, col, row, unitScale, deviceScale: this.template.scale
    }

    this.blockContainerStyle = {
      width: allWidth + 'px',
      height: allHeight + 'px',
      left: left + 'px',
      top: top + 'px'
    }

    this.splicingView = new Array(total).fill({
      width: `${singleWidth}px`,
      height: `${singleHeight}px`
    });

    this.$nextTick(() => {
      this.initTemplates(true);
      this.getColorRang();
    });
  },

  methods: {
    /** 拼接槽位是否为挖洞（仅 UI） */
    isSplicingHole(index) {
      if ((this.splicingHoleIndexes || []).includes(index)) return true;
      const device = (this.deviceList || [])[index];
      return !!device && !!device.IsDel;
    },

    addSplicingHole(index) {
      if (typeof index !== 'number' || index < 0) return;
      if (this.splicingHoleIndexes.includes(index)) return;
      this.splicingHoleIndexes = [...this.splicingHoleIndexes, index].sort((a, b) => a - b);
      this.ensureActiveSplicingView();
    },

    /**
     * 手动删除用：deletedListIndex 是删之前设备列表下标；
     * 拼图洞位 = 在「未挖洞槽位」里的第 deletedListIndex 个
     */
    addSplicingHoleByDeviceListIndex(deletedListIndex) {
      if (typeof deletedListIndex !== 'number' || deletedListIndex < 0) return;
      const total = (this.colRowOption?.col || 0) * (this.colRowOption?.row || 0) || (this.renderList || []).length;
      let deviceCursor = 0;
      for (let slot = 0; slot < total; slot++) {
        if (this.splicingHoleIndexes.includes(slot)) continue;
        if (deviceCursor === deletedListIndex) {
          this.addSplicingHole(slot);
          return;
        }
        deviceCursor += 1;
      }
    },

    syncHolesFromDeviceList(deviceList = []) {
      const holes = [];
      (deviceList || []).forEach((device, index) => {
        if (device && device.IsDel) holes.push(index);
      });
      this.splicingHoleIndexes = holes;
      this.ensureActiveSplicingView();
    },

    ensureActiveSplicingView() {
      if (!this.isSplicingHole(this.activeSplicingView)) return;
      const total = (this.renderList || []).length || ((this.colRowOption?.col || 0) * (this.colRowOption?.row || 0));
      for (let i = 0; i < total; i++) {
        if (!this.isSplicingHole(i)) {
          this.activeSplicingView = i;
          if (this.bg) {
            this.getBgColor(this.bg, true, {
              activeSplicingView: i,
              ...this.blockContainerData,
              splicingBgStyle: this.splicingBgStyle,
              isRender: true,
              isResetPointer: false
            });
          }
          return;
        }
      }
    },

    /**
     * 编辑时回显数据
     * @param {*} param0 
     */
    initData({ bg, renderList, splicingBgStyle, imageMode, isShadowOpen, isNeedMirror, splicingHoles }) {
      this.bg = bg;
      this.renderList = renderList;
      this.$refs.sceneBgSelect.setBg(bg);

      this.shadowValue = isShadowOpen ? 1 : 0;
      this.splicingBgStyleAche = splicingBgStyle || {
        ...this.splicingBgStyle,
        left: 0,
        top: 0,
        scale: 1
      };
      this.splicingBgStyle = splicingBgStyle || {
        ...this.splicingBgStyle,
        left: 0,
        top: 0,
        scale: 1
      };

      this.isNeedMirror = isNeedMirror;
      this.imageMode = imageMode === undefined ? 1 : imageMode;
      this.splicingHoleIndexes = Array.isArray(splicingHoles) ? [...splicingHoles] : [];

      this.initTemplates(false, false);
      this.$nextTick(() => this.ensureActiveSplicingView());
    },

    onSwitchValue(val) {
      this.renderList[this.activeSplicingView] = this.renderList[this.activeSplicingView].map(item => {
        if (item.isSelected) {
          return {
            ...item,
            switch: val === 1
          }
        }
        return item;
      });
    },

    hasValidCxCyPrecision(str) {
      const decimalPart = String(str ?? '').trim().split('.')[1]
      return !decimalPart || decimalPart.length <= 4
    },
    handleCxCyInput(field, value) {
      let str = String(value ?? '').replace(/[^\d.]/g, '')
      const dotIndex = str.indexOf('.')
      if (dotIndex !== -1) {
        str = str.slice(0, dotIndex + 1) + str.slice(dotIndex + 1).replace(/\./g, '')
      }
      const parts = str.split('.')
      if (parts[1] && parts[1].length > 4) {
        this.$message.warning(this.$t('deviceMsg.cxCyEmpty'))
        str = `${parts[0]}.${parts[1].slice(0, 4)}`
      }
      this.showCxCy = {
        ...this.showCxCy,
        [field]: str
      }
    },
    onCxCyChange() {
      const cxStr = String(this.showCxCy.cx ?? '').trim()
      const cyStr = String(this.showCxCy.cy ?? '').trim()

      if (!cxStr || !cyStr) {
        this.$message.warning(this.$t('deviceMsg.cxCyEmpty'))
        return
      }

      if (!/^\d+(\.\d+)?$/.test(cxStr) || !/^\d+(\.\d+)?$/.test(cyStr)) {
        this.$message.warning(this.$t('deviceMsg.cxCyFormatError'))
        return
      }

      if (!this.hasValidCxCyPrecision(cxStr) || !this.hasValidCxCyPrecision(cyStr)) {
        this.$message.warning(this.$t('deviceMsg.cxCyEmpty'))
        return
      }

      const cx = Number(cxStr)
      const cy = Number(cyStr)
      if (Number.isNaN(cx) || Number.isNaN(cy)) {
        this.$message.warning(this.$t('deviceMsg.cxCyFormatError'))
        return
      }

      if (!(cx >= 0 && cx <= 1 && cy >= 0 && cy <= 1)) {
        this.$message.warning(this.$t('deviceMsg.cxCyOutOfRange'))
        return
      }

      const a = parseInt(cx * 10000, 10) & 0xffff
      const b = parseInt(cy * 10000, 10) & 0xffff
      const value = (a << 16) | b
      this.onCaiGuangSubmit({ cx, cy, value })
    },

    onShadowValue(val) {
      const isSwitch = val === 1;
  
      this.renderList = this.renderList.map(list => {
        return list.map(item => {
          return {
              ...item,
              switch: item.shadow ? isSwitch : item.switch,
            }
        });
      });
    },
  
    getCanvasOption() {
      const splicingBgStyle = this.splicingBgStyle;
      const { col, row } = this.colRowOption;

      return {
        row,
        col,
        isShadowOpen: this.shadowValue === 1,
        imageMode: this.imageMode,
        splicingHoles: [...(this.splicingHoleIndexes || [])],
        ...splicingBgStyle
      }
    },

    getCanvasStageSize() {
      return {
        width: 700,
        height: this.sceneLightColorSetMainHeight
      }
    },

    getPosition() {
      return this.renderList.map((list, index) => {
        let posData = [];

        list.forEach(item => {
          posData.push({
            x: item.position.pX,
            y: item.position.pY,
            shadow: item.shadow,
            switch: item.switch
          });
        });

        const device = this.deviceList[index] || {};

        return {
          id: index,
          posData,
          deviceScale: this.template.scale,
          deviceIsGroup: this.template.isGroup,
          shape: this.template.shape,
          deviceList: [{
            VDeviceId: device.VDeviceId,
            Mac: device.Mac,
            ChannelId: device.ChannelId,
          }]
        }
          // posStr+= ` ${item.position.x},${item.position.y},${item.shadow ? 1 : 0},${item.switch ? 1 : 0}`
          //  posStr+= ` ${item.position.pX},${item.position.pY},${item.shadow ? 1 : 0},${item.switch ? 1 : 0}`
      });

        // return posStr.substring(1);
    },

    changeActiveSplicingView(e, index) {
      if (this.isSplicingHole(index)) return;

      this.activeSplicingView = index;

      const activeSplicingView = index;
      const { col, row } = this.colRowOption;
      const size = Math.floor(300 / Math.max(col, row));

      if (row > col) {
        this.blockContainerWidth = Math.floor(col * size);
      };

      // const stX = (activeSplicingView % option.col)
      // const stY = Math.floor(activeSplicingView / option.col)

      this.getBgColor(this.bg, true, {
        activeSplicingView,
        ...this.blockContainerData,
        // col,
        // row,
        splicingBgStyle: this.splicingBgStyle,
        isRender: true,
        isResetPointer: false
      });
    },
  
    async getColorRang() {
      try {
        const res = await FindActionAbilityWithStatus({
          classSku: this.device.ClassSku,
          vDeviceId: this.device.VDeviceId,
          channelId: this.device.ChildId
        });

        const actionList = (res.Result || []).reduce((pre, next) => pre.concat(next.ActionList), []);
        // let colorConfigItem = null;

        for (let i = 0; i < actionList.length; i++) {
          const item = actionList[i];

          const colorValue = (item.Values || []).find(val =>  UICONTROL_CX_CY_WithMode_ARRAY.includes(val.ValueType));


          if (!!colorValue && item.UI.extra) {
            this.colorAction = {
              ...item,
              Icon: colorValue.UI?.Icon
            };
            // this.colorModel = colorValue
            break;
          }
        }
        // if (colorConfigItem) {
        //   this.colorAction = colorConfigItem;
        // }
        // console.log('gggg', colorConfigItem);
      } catch (e) {

      }
    },

    // 统一设置灯具亮度色温duv
    setOption(value) {
      this.renderList.forEach((item, index) => {
        this.renderList[index] = this.renderList[index].map(item => {
          return {
            ...item,
            ...value,
            // isSelected: false,
          };
        });
      });
    },

    // 初始化模板点位
    initTemplates(isNeedRefreshColor = true, isNeedRefreshList = true) {
      const { col, row } = this.colRowOption;
      const deviceCount = col *  row;

      console.log('this.template', this.template);
      
      if (!Array.isArray(this.template.posList)) return;

      this.sceneLightColorSetMainHeight = 700 * (this.template.scale || 1);

      for (let i = 0; i < deviceCount; i++) {
        const singleRenderList = [];

        this.template.posList.forEach(element => {
          const { id, x, y, shadow } = element;

          singleRenderList.push({
            id,
            position: {
              x: Math.max(x, 0),
              y: Math.max(y, 0),
            },
            color: '#fff',
            shadow: shadow || false,
            switch: true
          });
        });

        isNeedRefreshList && this.renderList.push(singleRenderList);

        this.getBgColor(this.bg, true, {
          activeSplicingView: i,
          // col,
          // row,
          splicingBgStyle: this.splicingBgStyle,
          ...this.blockContainerData,
          isRender: i === this.activeSplicingView,
          isResetPointer: isNeedRefreshColor,
        });
      }

      const size = Math.floor(300 / Math.max(col, row));

      if (row > col) {
        this.blockContainerWidth = Math.floor(col * size);
      }

      // this.renderList = new Array(deviceCount).fill();

      // const activeSplicingView = this.activeSplicingView;

      // const total = option.col * option.row;
      
    },

    getBgColor(val, isNeedResetSelect = true, option = null) {
      const activeSplicingView = option ? option.activeSplicingView : 0;
      const isResetPointer = option ? option.isResetPointer : false;
      console.log('gagaga', this.matrixValueUi);
    
      getPixelColor(val, this.renderList[activeSplicingView], { ...(option || {}), ctx: this.ctx, ctxVirtually: this.ctxVirtually, matrixValueUi: this.matrixValueUi })
        .then(({ bgStyle, colorList, hexList, cxcyValueList, ctx, ctxVirtually, splicingBgStyle }) => {
          console.log('this.renderList 00', this.renderList);

          if (colorList.length !== (this.renderList[activeSplicingView] || []).length) return;

          if (!this.ctx) this.ctx = ctx;
          if (!this.ctxVirtually) this.ctxVirtually = ctxVirtually;

          this.bgStyle = bgStyle;
          this.splicingBgStyle = {
            ...this.splicingBgStyle,
            ...splicingBgStyle
          }

          this.splicingBgStyleAche = {
            ...this.splicingBgStyleAche,
            ...splicingBgStyle
          }

          // console.log('this.splicingBgStyle 222', this.splicingBgStyle);
          // console.log('cxcyValueList cxcyValueList', cxcyValueList);
          
          // console.log('this.renderList 11', isResetPointer, colorList, activeSplicingView, this.renderList);

          // if (isResetPointer === false) return;

          const newRenderList = this.renderList.map((list, index) => {
            if (index === activeSplicingView) {
              return list.map((item, index) => {
                const colorInfo = colorList[index];
                const hex = hexList[index];
                const cxcyValue = cxcyValueList[index];
                // console.log('colorInfo', colorInfo, hex, cxcyValue);
                // const bb = transformPointToCXCY({
                //   color: `${colorInfo.r},${colorInfo.g},${colorInfo.b},255`,
                //   light: 255,
                //   mode: 'V2'
                // }, this.matrixValueUi);
                // const ccc = OppColorCvrtCIExy2sRgb({
                //   x: 0.32114, 
                //   y: 0.59787
                // });

                const sdlRgb = transformPointToSdlRgb({
                  color: `${colorInfo.r},${colorInfo.g},${colorInfo.b},255`,
                  light: 255,
                  mode: 'V2'
                }, this.matrixValueUi)

                // 没有编辑编辑过的或者直接需要覆盖的
                if (!item.hasEdit || isResetPointer) {
                  return {
                    ...item,
                    colorData: { ...colorInfo },
                    color: `rgb(${colorInfo.r},${colorInfo.g},${colorInfo.b})`,
                    sdlColor: `rgb(${sdlRgb.r},${sdlRgb.g},${sdlRgb.b})`,
                    isSelected: isNeedResetSelect ? false : item.isSelected,
                    lightMode: 2,
                    hasEdit: false,
                    hex,
                    cxcyValue
                  }
                };

                return item;
              });
            }

            return list;
          })
          console.log('this.renderList 22', newRenderList);
          this.renderList = newRenderList;
        });
    },

    handlerItemDbClick(item, index) {
      setTimeout(() => {
        const lastSelect = item.isSelected;

        // item.isSelected = !lastSelect;
        const curColor = item.color;

        this.renderList = this.renderList.map(list => {
          return list.map(item => {
            if (item.color === curColor) {
              return {
                ...item,
                isSelected: !lastSelect,
              }
            } else {
              return item;
            }
          })
        });

        if (!lastSelect) {
          this.option = {
            light: item.light,
            duv: item.duv,
            temperature: item.temperature,
          }

          this.lightMode = item.lightMode;
          this.colorModel = item.cxcyValue;
          this.lightBg = item.color;
          this.switchValue = item.switch ? 1 : 0;
        }
      })
    },

    handlerItemClick(item, index) {
      const lastSelect = item.isSelected;

      item.isSelected = !lastSelect;
     
      this.renderList = this.renderList.slice();

      const { cx, cy } = ValueToCxCy(item.cxcyValue)

      this.showCxCy = {
        cx: cx.toFixed(4),
        cy: cy.toFixed(4)
      }

      if (!lastSelect) {
        this.option = {
          light: item.light,
          duv: item.duv,
          temperature: item.temperature,
        }

        this.lightMode = item.lightMode;
        this.colorModel = item.cxcyValue;
        this.lightBg = item.color;
        this.switchValue = item.switch ? 1 : 0;
      }
    },

    onOptionChange(value) {
      this.option = { ...value.payload };

      this.renderList[this.activeSplicingView].filter(item => item.isSelected).forEach(item => {
        if (this.lightMode === 2) {
          item.light = value.payload.light
        }
      });

      if (this.lightMode === 1) {
        this.onRiguangcSubmit();
      }
    },

    // 日光
    onRiguangcSubmit() {
      this.renderList[this.activeSplicingView] = this.renderList[this.activeSplicingView].map(item => {
        const color = getTemperatureColor(
          this.option.temperature, [
          this.optionRange.temperature.Min, 
          this.optionRange.temperature.Max
        ]);

        if (item.isSelected) {
          return {
            ...item,
            light: this.option.light,
            duv: this.option.duv,
            temperature: this.option.temperature,
            lightMode: this.lightMode,
            hasEdit: true,
            colorData: { ...color },
            color: `rgb(${color.r},${color.g},${color.b})`,
            sdlColor: `rgb(${color.r},${color.g},${color.b})`, // 色温都是支持的
          }
        };

        return item;
      })

      this.renderList = this.renderList.slice();
    },

    // 彩光
    onCaiGuangSubmit(model) {
      console.log('onCaiGuangSubmit', model);

      this.showCxCy.cx = model.cx.toFixed(4)
      this.showCxCy.cy = model.cy.toFixed(4)

      const hex = CxCyToRGBHex(model.cx, model.cy);

      this.colorModel = model.value;
      this.lightBg = hex;
      const rgbData = hexToRgb(this.lightBg);

      const sdlRgb = transformPointToSdlRgb({
        color: `${rgbData.r},${rgbData.g},${rgbData.b},255`,
        light: 255,
        mode: 'V2'
      }, this.matrixValueUi)
  
      this.renderList[this.activeSplicingView] = this.renderList[this.activeSplicingView].map(item => {
        if (item.isSelected) {
          return {
            ...item,
            color: rgbData.rgb,
            colorData: { r: rgbData.r, g: rgbData.g, b: rgbData.b },
            sdlColor: `rgb(${sdlRgb.r},${sdlRgb.g},${sdlRgb.b})`,
            light: this.option.light,
            duv: this.option.duv,
            temperature: this.option.temperature,
            lightMode: this.lightMode,
            hasEdit: true,
            cxcyValue: model.value
          }
        };

        return item;
      });
    },
  
    async onImgUpdate(url, title) {
      const { col, row } = this.colRowOption;
      const deviceCount = col * row;

      this.bg = url;

      if (!!title) {
        this.$emit('imgUpdate', { title })
      }

      // 首次进来没有renderList
      if (this.renderList.length === 0) return;

      this.lightMode = 1;
      this.colorModel = '';
      this.splicingBgStyle = {
        ...this.splicingBgStyle,
        left: 0,
        top: 0,
        scale: 1
      };

      for (let i = 0; i < deviceCount; i++) {
        this.getBgColor(url, true, {
          activeSplicingView: i,
          // col,
          // row,
          splicingBgStyle: this.splicingBgStyle,
          ...this.blockContainerData,
          isRender: i === this.activeSplicingView,
          isResetPointer: true
        }); 
      };

      if (this.defaultOptionAche) {
        for (let i = 0; i < deviceCount; i++) {
          this.renderList[i] = this.renderList[i].map(item => {
            return {
              ...item,
              light: this.defaultOptionAche.light,
              duv: this.defaultOptionAche.duv,
              temperature: this.defaultOptionAche.temperature,
              isSelected: false,
            }
          });
        };
      };

      this.$emit('resetOption');
    },

    getBg() {
      return this.bg;
    },

    getRenderList() {
      return this.renderList.map(list => {
        return list.map(item => {
          return {
            colorData: item.colorData,
            cxcyValue: item.cxcyValue,
            duv: item.duv,
            hasEdit: item.hasEdit,
            id: item.id,
            light: item.light,
            lightMode: item.lightMode,
            position: item.position,
            sdlColor: item.sdlColor,
            shadow: item.shadow,
            switch: item.switch,
            temperature: item.temperature,
          }
        })
      });
    },

    onCancelAll() {
      const newRenderList = this.renderList.map((list, i) => {
        if (this.activeSplicingView === i) {
          return list.map(item => {
            return {
              ...item,
              isSelected: false,
            }
          })
        } 

        return list;
      });

      this.renderList = newRenderList;

      console.log('onCancelAll', newRenderList);
    },

    onScale(type) {
      const { splicingBgStyle } = this;
      let scale = 1;

      // 变大
      if (type === 1) {
        scale = splicingBgStyle.scale + 0.1;
      };

      // 变小
      if (type === 0) {
        scale = Math.max(splicingBgStyle.scale - 0.1, 1)
      };

      this.splicingBgStyle = {
        ...splicingBgStyle,
        scale
      };

      const { col, row } = this.colRowOption;
      const deviceCount = col * row;

      for (let i = 0; i < deviceCount; i++) {
        this.getBgColor(this.bg, true, {
          activeSplicingView: this.activeSplicingView,
          // col,
          // row,
          splicingBgStyle: this.splicingBgStyle,
          ...this.blockContainerData,
          isRender: i === this.activeSplicingView,
          isResetPointer: false,
        });
      }
    },

    onImgDown(e) {
      console.log('onImgDown onImgDown', e);   
      const { screenX, screenY } = e;

      this.mouseDownAche = {
        top: screenY,
        left: screenX
      };
    },

    onImgUpMove(e) {
      const { screenX, screenY } = e;
      const { left: stScreenX, top: stScreenY } = this.mouseDownAche;
      const splicingBgStyleAche = this.splicingBgStyleAche;

      if (!Number.isInteger(stScreenX)) {
        return;
      }

      const splicingBgStyle = this.splicingBgStyle;

      const minusX = screenX - stScreenX;
      const minusY = screenY - stScreenY;
      this.splicingBgStyle = {
        ...splicingBgStyle,
        left: (splicingBgStyleAche.left || 0) + minusX + 'px',
        top: (splicingBgStyleAche.top || 0) + minusY + 'px',
      },
      this.isShowNumSpan = false;
    },

    onImgUp() {
      const { left: stScreenX, top: stScreenY } = this.mouseDownAche;

      if (!Number.isInteger(stScreenX)) {
        return;
      }

      this.mouseDownAche = {
        top: null,
        left: null
      };

      // const left = parseInt(this.splicingBgStyle.left);
      // const top = parseInt(this.splicingBgStyle.top);

      this.splicingBgStyleAche = {
        ...this.splicingBgStyle,
        left: parseInt(this.splicingBgStyle.left),
        top: parseInt(this.splicingBgStyle.top),
      };

      const { col, row } = this.colRowOption;

      const deviceCount = col * row;
      console.log('this.renderList 33', this.renderList);

      for (let i = 0; i < deviceCount; i++) {
        this.getBgColor(this.bg, true, {
          // col,
          // row,
          ...this.blockContainerData,
          splicingBgStyle: this.splicingBgStyle,
          activeSplicingView: i,
          isRender: i === this.activeSplicingView,
          isResetPointer: false,
        });
      };

      this.isShowNumSpan = true;
    },

    setValue(value) {
      const { payload } = value;
      const activeSplicingView = this.activeSplicingView;

      this.renderList.forEach((item, index) => {
        this.renderList[index] = this.renderList[index].map(item => {
          const color = item.lightMode === 1 ? getTemperatureColor(
            payload.temperature, 
            [
              this.optionRange.temperature.Min, 
              this.optionRange.temperature.Max
            ]
          ) : item.colorData;
          
          if (item.lightMode === 1) {
            console.log('color', color);
          }

          return {
            ...item,
            light: payload.light,
            duv: payload.duv,
            temperature: payload.temperature,
            color: `rgb(${color.r},${color.g},${color.b})`,
            colorData: color
          }
        });
      });

      // this.renderList = this.renderList.map(item => {
      //   const color = item.lightMode === 1 ? getTemperatureColor(
      //     payload.temperature, [
      //     this.optionRange.temperature.Min, 
      //     this.optionRange.temperature.Max
      //   ]) : item.colorData;
        
      //   if (item.lightMode === 1) {
      //     console.log('color', color);
      //   }

      //   return {
      //     ...item,
      //     light: payload.light,
      //     duv: payload.duv,
      //     temperature: payload.temperature,
      //     color: `rgb(${color.r},${color.g},${color.b})`,
      //     colorData: color
      //   }
      // });

      this.option = {
        light: payload.light,
        duv: payload.duv,
        temperature: payload.temperature,
      }
      // if (value.type === 'light') {
      //   const light = value.payload.light;

      //   // this.lightValue = lightProps;
      //   this.renderList = this.renderList.map(item => {
      //     return {
      //       ...item,
      //       light,
      //       // isSelected: false,
      //     }
      //   })
      // }
      
      // if (value.type === 'duv') {
      //   const duv = value.payload.duv;

      //   // this.duvModel = duv;
      //   this.renderList = this.renderList.map(item => {
      //     return {
      //       ...item,
      //       duv,
      //       // isSelected: false,
      //     }
      //   })
      // }
      
      // if (value.type === 'temperature') {
      //   const temperature = value.payload.temperature;
      //   // this.temperatureValue = temperature;

      //   this.renderList = this.renderList.map(item => {
      //     return {
      //       ...item,
      //       temperature,
      //       // isSelected: false,
      //     }
      //   })

      // }
    }
  },
};
</script>

<style lang="scss" scoped>
.scene-lightColorSet {
  #scene-splicing-view-shoot {
    width: 300px;
    height: 300px;
    background: #000;
  }

  &_row {
    display: flex;

    &_modeSelect {
      display: flex;
      justify-content: center;
      margin-top: 18px;

      &>div {
        padding: 6px 12px;
        border: 1px solid #eee;
        border-radius: 3px;
        margin-right: 10px;
        cursor: pointer;

        &.active {
          background: #002a91;
          color: #fff;
        }
      }
    }
  }
  

  .scene-splicing-view {
    position: relative;
    width: 300px;
    height: 300px;
    margin-bottom: 10px;
    cursor: pointer;
    overflow: hidden;
    border: 2px solid #222;

    &_blockContainer {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      z-index: 3;
      // background-color: #000;
    }

    &_block {
      position: relative;
      // position: absolute;
      float: left;
      box-sizing: border-box;
      border: 2px solid #222;


      &.circle {
        border-radius: 50%;
      }

      &.is-hole {
        background: rgba(0, 0, 0, 0.55);
        border-style: dashed;
        border-color: #666;
        pointer-events: none;

        &::after {
          content: '';
          position: absolute;
          inset: 0;
          background: repeating-linear-gradient(
            -45deg,
            transparent,
            transparent 6px,
            rgba(255, 255, 255, 0.08) 6px,
            rgba(255, 255, 255, 0.08) 12px
          );
        }
      }

      span {
        position: absolute;
        width: 24px;
        height: 24px;
        left: 50%;
        top: 50%;
        transform: translate3d(-50%, -50%, 0);
        background-color: #222;
        border-radius: 50%;
        color: #fff;
        text-align: center;
        line-height: 24px;
        user-select: none;
        border: 2px solid #fff;

        &.active {
          background-color: red;
        }
      }
    }

    &_bg {
      position: absolute;
      width: 300px;
      // height: 300px;
      user-select: none;
      pointer-events: none
    }

    &_scale {
      display: flex;
      align-items: center;
      position: absolute;
      padding: 4px 6px;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.8);
      color: #fff;
      z-index: 5;
      user-select: none;

      span {
        font-size: 17px;
        margin-left: 4px;
        margin-right: 4px;
      }
    }
  }
  

  &_main {
    position: relative;
    width: 700px;
    // height: 700px;
    overflow: hidden;

    &_colorPicker {
      display: none;
      position: absolute;
      left: 50%;
      top: 20px;
      transform: translateX(-50%);
    }

    &_pngBg {
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      background-size: 40px 40px;
      z-index: 5;

      // &.mirror {
        // transform: rotateY(180deg);
      // }
    }

    // &_bg {
    //   position: absolute;
    //   left: 0;
    //   top: 0;
    //   z-index: 2;
    // }

    #scene-lightColorSet_canvas {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;

      &-virtually {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        opacity: 0;
      }
    }

    &_masker {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      z-index: 3;
      background-color: rgba(0, 0, 0, 0.6);
    }

    &_positionList {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      z-index: 5;

      &_edit {
        position: absolute;
        width: 10px;
        height: 10px;
        right: -6px;
        bottom: -4px;
        border-radius: 50%;
        background-color: #019c10;
      }
  
      li {
        position: relative;
        border-radius: 50%;
        width: 14px;
        height: 14px;
        position: absolute;
        background-color: #fff;
        cursor: pointer;
        border: 4px solid transparent;
        transition: .2s;
        user-select: none;
        line-height: 14px;
        text-align: center;

        &.active {
          border: 2px solid #fff;
          transform: scale(1.3);
          box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.5);
        }

        // img {
          
        // }
      }
    }
  }

  &_control {
    position: relative;
    width: 300px;
    height: 400px;
    padding: 20px;
    margin-left: 50px;
    background-color: #fff;

    &_switchs {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      &_item {
        margin-right: 40px;

        span {
          margin-right: 10px;
        }
      }
    }

    &_submit {
      width: 110px;
      height: 40px;
      font-size: 14px;
      line-height: 40px;
      text-align: center;
      background-color: #002a91;
      border-radius: 4px;
      color: #fff;
      cursor: pointer;
    }

    &_btnList {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
    }
  
    .el-color-picker {
      position: absolute;
      border-radius: 50%;
      left: 50%;
      top: 16px;
      transform: translate(-50%, 0);
    }

    &_color {
      // position: absolute;
      width: 60px;
      height: 60px;
      border: 2px solid #999;
      border-radius: 50%;
      // top: 0;
      // left: 50%;
      // transform: translateX(-50%);
      margin: 0 auto 20px;
      z-index: 10;
      cursor: pointer;
    }

    &_colorPicker {
      & > div:before {
        display: none;
      }
    }
    &_item {
      position: relative;
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      &.colorPicker {
        align-items: flex-start;
        height: 422px;

        .scene-lightColorSet_control_submit {
          position: absolute;
          left: 0;
          bottom: 0;
        }

        .scene-lightColorSet_control_cxcyText {
          display: flex;
          align-items: center;
          padding-top: 4px;

          ::v-deep {
            .el-input {
              width: 74px;
              height: 20px;
              margin: 0 5px;
            }

            .el-input__inner {
              height: 20px;
            }
          }
          
          // white-space: nowrap;
        }
      }
    }

    &_label {
      width: 120px;
      white-space: nowrap;
    }

    &_value {
      &.duv,
      &.light {
        display: flex;
        width: 300px;

        .slide_input {
          flex: 1;
        }
      }
    }

  }

  .color-picker-box {
    transform: translateY(100px);
  }
}
</style>
<style lang="scss">
.scene-lightColorSet_control_slider {
  display: flex;
  align-items: center;
  width: 100%;
  .el-slider__input.el-input-number.el-input-number--small {
    width: auto;
  }

  .el-slider__runway.show-input {
    flex: 1;
  }

  .el-slider__runway.show-input {
    margin: 0;
  }

  .el-input.el-input--small {
    input {
      width: 40px;
      padding: 0 !important;
    }
    // width: 40px;
    
  }
}
.scene-lightColorSet_color-picker {
  .el-color-picker__trigger {
    // opacity: 0;
  }
}
.color-picker-box {
  position: absolute !important;
  display: block !important;
  left: 0;
  top: 0;
  transform: translate3d(-44%, 60px, 0);

  &.el-color-picker__panel {
    box-shadow: none !important;
    border: 0px solid #eee;

    .el-color-dropdown__btns {
      .el-input {
        display: none;
      }
      .el-color-dropdown__link-btn {
        display: none;
      }
    }

    button.el-button.el-button--default {
      margin-top: 20px;
      padding: 12px 40px;
      background-color: #002a91 !important;
      color: #fff !important;

      :hover {
        background-color: #002a91 !important;
        color: #fff !important;
      }
    }
  }
}

// .lightColorSet_control_colorPicker {
//   .color-panel {
//     margin-top: 60px;
//   }
// }
</style>